module.exports = __webpack_public_path__ + "static/media/lexx-logo.1ba4b2c4.png";